export default defineNuxtPlugin(() => {
  const warn = console.warn
  console.warn = (...msg) => {
    if (String(msg[0]).startsWith('[Vue Router warn]: No match')) return
    warn(...msg)
  }
})
